export default __webpack_public_path__ + "static/media/device-models.84ae6581.jpg";